export const getShowAnswerBtn = (state: any) => state.showanswerbtn;
export const getShowAnswerBtnStatus = (state: any) => getShowAnswerBtn(state).get('status');